import { render, staticRenderFns } from "./zhixing.vue?vue&type=template&id=38d5f9f0"
import script from "./zhixing.vue?vue&type=script&lang=ts"
export * from "./zhixing.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports